import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../../hooks/useAuthContext";
import "./Mesas.css";
import {
  utilGetMesas,
  utilGetCollectionFilter,
  utilUpdateTables,
  utilGetDocumentById,
} from "../../../util/UtilsFirebase";
import ModalMesa from "./ModalMesa";

export default function Mesas() {
  const { register } = useAuthContext();
  const [mesas, setMesas] = useState([]);
  const [asignaciones, setAsignaciones] = useState([]);
  const [asignacionesMostrar, setAsignacionesMostrar] = useState([]);
  const [data, setData] = useState([]);
  const [numMes, setNumMes] = useState(1);
  const [showProdForm, setShowProdForm] = useState(false);

  const handleCloseProd = () => {
    setShowProdForm(false);
  };

  const OpenModal = (mesa) => {
    setNumMes(mesa);
    setShowProdForm(true);
  };

  useEffect(() => {
    async function getMesas() {
      const fetchOrders = await utilGetCollectionFilter(
        "mesas",
        "id_puesto",
        "==",
        register.id
      );
      if (fetchOrders.length !== 0) {
        const invent = await utilGetMesas(fetchOrders[0].id);
        setMesas({
          ...invent,
          id: fetchOrders[0].id,
        });
        setAsignaciones(invent.asignaciones);
        for (let index = 0; index < register.table; index++) {
          const numMe = index + 1;
          const iduser = invent.asignaciones[0]["Mesa " + numMe]
            ? invent.asignaciones[0]["Mesa " + numMe]["Mesero"]
            : "";
          const personal = await utilGetDocumentById("personal", iduser);
          if (personal != null) {
            const users = await utilGetCollectionFilter(
              "users",
              "id",
              "==",
              personal.id_usuario
            );
            invent.asignaciones[0]["Mesa " + numMe]["datos"] = users[0];
          } else if (invent.asignaciones[0]["Mesa " + numMe]) {
            invent.asignaciones[0]["Mesa " + numMe]["datos"] = "";
          }
        }
        await setAsignacionesMostrar(invent.asignaciones);
      } else {
        const inventarioid = await utilUpdateTables(
          register.table,
          register.id
        );
        const inventa = await utilGetMesas(inventarioid);
        setMesas({ ...inventa, id: inventarioid });
        setAsignaciones(inventa.asignaciones);
      }
    }
    getMesas();
    let info = [];
    for (let index = 0; index < register.table; index++) {
      var qrText = "/../../images/table1.png";
      var mesa = index + 1;
      info.push({
        nombre: "Mesa " + mesa,
        qr: qrText,
        numMesa: mesa,
      });
    }
    setData(info);
  }, [register.id, register.table]);

  return (
    <div>
      <iframe
        title="Frm"
        className="iframePrint"
        id="ifmcontentstoprint"
      ></iframe>
      <br />
      <div id="project-qr" className="row">
        <div className="">
          <h4 className="page-title">MESAS</h4>
          <br />
        </div>
      </div>
      <div id="project-qr" className="row">
        {data.map((n) => (
          <div className="col-4">
            <div className="center">
              <button
                id="al"
                style={{ backgroundColor: "#E9E9E9" }}
                onClick={() => OpenModal(n.numMesa)}
              >
                <img alt="" className="qr-code" src={n.qr}></img>
                <div className="center" style={{ color: "black" }}>
                  {n.nombre}
                </div>
                {!register.type.includes("truck-admin") ? (
                  <>
                    <div className="center" style={{ color: "black" }}>
                      No molestar:{" "}
                      {asignacionesMostrar[0] &&
                      asignacionesMostrar[0][n.nombre]
                        ? asignacionesMostrar[0][n.nombre]["no_molestar"]
                          ? " activo"
                          : " inactivo"
                        : ""}
                    </div>
                    <div className="center" style={{ color: "black" }}>
                      Mesero:{" "}
                      {asignacionesMostrar[0] &&
                      asignacionesMostrar[0][n.nombre]
                        ? asignacionesMostrar[0][n.nombre]["datos"]
                          ? asignacionesMostrar[0][n.nombre]["datos"][
                              "fullName"
                            ]
                          : ""
                        : ""}
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </button>
            </div>
          </div>
        ))}
      </div>
      <hr />
      <ModalMesa
        NumMesa={numMes}
        showProducto={showProdForm}
        MesasID={mesas.id}
        asignaciones={asignaciones}
        handleCloseProducto={handleCloseProd}
      ></ModalMesa>
    </div>
  );
}
